import { Flex, Box } from '@chakra-ui/react'
import React from 'react'

const MakePayment = () => {
  return (
      <>
      <Flex justifyContent='center' bg='#e5e5e5'>
          <Box>

          </Box>
      </Flex>
      </>
  )
}

export default MakePayment
